import {useState, useEffect} from 'react';
/**
 * Hook for handling closing when clicking outside of an element
 * @param {React.node} el
 * @param {boolean} initialState
 */
export const outsideClick = (el, initialState) => {
  // TODO
  // eslint-disable-next-line
  const [isActive, setIsActive] = useState(initialState);

  // TODO
  // eslint-disable-next-line
  useEffect(() => {
    const onClick = (e) => {
      if (el.current !== null && !el.current.contains(e.target)) {
        setIsActive(!isActive);
      }
    };

    if (isActive) {
      window.addEventListener('click', onClick);
    }

    return () => {
      window.removeEventListener('click', onClick);
    };
  }, [isActive, el]);

  return [isActive, setIsActive];
};
